import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-routers',
    templateUrl: './routers.component.html',
    styleUrls: ['./routers.component.scss'],
    standalone: false
})
export class RoutersComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
